import { backendApi } from "../dynamicBAseQuery";

export const ProfileApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        ViewRecruiterDetailsById: builder.query({
            query: () => ({
                method: "GET",
                url: `ViewRecruiterDetailsById`
            })
        }),

        UpdateRecruiter: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `UpdateRecruiter`,
                body: { ...args }
            })
        }),
        ViewRecruiterDetailsByIdForAdmin: builder.query({
            query: (args) => ({
                method: "GET",
                url: `ViewRecruiterDetailsByIdForAdmin`,
                params: { ...args }
            })
        }),
        recruiterDeleteAccount: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `recruiterDeleteAccount`,
                body: args
            })
        }),
    })
})

export const {
    useViewRecruiterDetailsByIdQuery,
    useUpdateRecruiterMutation,
    useViewRecruiterDetailsByIdForAdminQuery,
    useRecruiterDeleteAccountMutation,
} = ProfileApi